import { ICreateIndicadoresUseCase } from "../../../presentation/useCases/create/create_indicadores_servicos_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

// CreateIndicadoresUseCase

export class CreateIndicadoresUseCase implements ICreateIndicadoresUseCase {
  constructor(private readonly repository: IQualidadeRepository) {}

  async createIndicadores(
    Item: string | null, Descricao: string | null, Indice: string | null, Frequencia: string | null, Meta: string | null, Ativo: boolean | null, Resultado: string | null
  ): Promise<void> {
    
    await this.repository.createIndicadores(
      Item, Descricao, Indice, Frequencia, Meta, Ativo, Resultado
    );
  }
}